export class ResultCumulative {
  t: Date = new Date();
  y: number = 0;
}

